<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <v-text-field
            label="Country Third ID"
            @input="updateThirdIdFiltered()"
            prepend-icon="mdi-magnify"
            v-model="sub_id"
            :prefix="`15- ${this.sub_id == null ? '' : this.sub_id} - `"
            solo
            clearable
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid>
      <v-simple-table class="elevation-10">
        <template v-slot:default>
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Name</th>
              <th scope="col">Code</th>
              <th scope="col">ThirdIdCountry</th>
              <th scope="col">Currency Code</th>
              <th scope="col">Overwrite Date</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="country in countries" v-if="isCountryFiltered(country)">
              <td>{{ country.id }}</td>
              <td>{{ country.name }}</td>
              <td>{{ country.code }}</td>
              <td>{{ country.thirdIdCountry }}</td>
              <td>{{ country.currencyCode }}</td>
              <td>{{ country.overwriteDate }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import { parameters } from "../../../parameters";
import { httpClient } from "../../../requesters/httpClient";

export default {
  name: "CountriesOverwritten",
  data() {
    return {
      countries: [],
      id: "15",
      sub_id: null,
      third_id_filtered: "15--",
    };
  },
  async mounted() {
    await httpClient
      .get(`${parameters.posdataRefUrl}/country-overwrittens`)
      .then((response) => {
        this.countries = response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  methods: {
    updateThirdIdFiltered: function () {
      this.sub_id = this.sub_id == null ? "" : this.sub_id;
      this.third_id_filtered = this.id + "-" + this.sub_id + "-" + this.sub_id;
    },

    isCountryFiltered: function (country) {
      return (
        this.third_id_filtered === "15--" ||
        this.third_id_filtered === country.thirdIdCountry
      );
    },
  },
};
</script>





// WEBPACK FOOTER //
// src/components/overwritten/countries/Countries.vue